import React, { useState, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import Layout from "../../../../Layout/Layout";
import { formatDate, formatDateWithAMPM } from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { InputField } from "../../../../Components/formElements/InputField";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import { useNavigate } from "react-router-dom";
import CustomerConstants from "../../../../common/CustomerConstants";


const BulkERFInvoiceCreation = () => {
  localStorage.setItem("menu", "Equipment Rent");
  localStorage.setItem("submenu", "ERF List");

    const navigate = useNavigate();
  
  // ── Accordion visibility states (mirrors ErfInvoiceModal) ──────────────────
  const [isCardVisible, setCardVisible] = useState(true); // Selected ERF List
  const [isCardVisible2, setCardVisible2] = useState(true); // Rent Items
  const [isCardVisible3, setCardVisible3] = useState(true); // Rent Totals
  const [isCardVisible4, setCardVisible4] = useState(true); // Sale Items
  const [isCardVisible5, setCardVisible5] = useState(true); // Sale Totals
  const [isCardVisible6, setCardVisible6] = useState(true); // Nursing Items
  const [isCardVisible7, setCardVisible7] = useState(true); // Nursing Totals
  const [isCardVisible8, setCardVisible8] = useState(true); // Service Items
  const [isCardVisible9, setCardVisible9] = useState(true); // Service Totals
    const [disable, setDisabled] = useState(false);
  

  // ─── Pull selected rows from Redux ─────────────────────────────────────────
  const selectedERFRows = useSelector(
    (state) => state?.customer?.selectedERFRows || []
  );

  // ─── Extract common address and billing info from first selected ERF ───────
  const firstERF = selectedERFRows?.[0] || {};

  const addressInfo = {
    companyName: "Medrient",
    address: "Basement Plot No 37, Electronic City, Sector 18, Udyog Vihar Phase IV, Gurugram - 122015",
    gst: "GST:06AAJCM7464L1ZW",
    email: "info@medrient.in",
    contact: "0124-4303235, 011-25522552",
    billingName: firstERF?.billingName || "Patient",
    billingAddress: firstERF?.billingAddress || firstERF?.address || "HSR LAYOUT, Sector 5, Bengaluru",
    billingState: firstERF?.billingState || "IN - Karnataka",
    billingPinCode: firstERF?.billingPinCode || "577501",
    deliveryAddress: firstERF?.deliveryAddress || firstERF?.address || "HSR LAYOUT, Sector 5, Bengaluru",
    deliveryState: firstERF?.deliveryState || "IN - Karnataka",
    deliveryPinCode: firstERF?.deliveryPinCode || "577500",
  };

  // ─── Merge all selected rows into ONE combined object ──────────────────────
  const mergedData = useMemo(() => {
    if (!selectedERFRows || selectedERFRows.length === 0) return null;

    const reNumber = (arr) =>
      arr.map((item, idx) => ({ ...item, equipmentItemNr: idx + 1 }));

    const sum = (key) =>
      selectedERFRows.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);

    const roundTwo = (val) => Math.round(val * 100) / 100;

    // Combine all item arrays and tag each with parent ERF doc number
    const allRentItems = reNumber(
      selectedERFRows.flatMap((row) =>
        (row.rentItems || []).map((item) => ({
          ...item,
      parentDocumentNumber: item.parentDocumentNumber || (row.documentNumbers?.[0]),
        }))
      )
    );
    const allSaleItems = reNumber(
      selectedERFRows.flatMap((row) =>
        (row.saleItems || []).map((item) => ({
          ...item,
          parentDocumentNumber: row.documentNumber,
        }))
      )
    );
    const allServiceItems = reNumber(
      selectedERFRows.flatMap((row) =>
        (row.serviceItems || []).map((item) => ({
          ...item,
          parentDocumentNumber: row.documentNumber,
        }))
      )
    );
    const allNursingItems = reNumber(
      selectedERFRows.flatMap((row) =>
        (row.nursingItems || []).map((item) => ({
          ...item,
          parentDocumentNumber: row.documentNumber,
        }))
      )
    );

    return {
      rentItems: allRentItems,
      saleItems: allSaleItems,
      serviceItems: allServiceItems,
      nursingItems: allNursingItems,
      // Rent totals
      rentNetTotal: roundTwo(sum("rentNetTotal")),
      rentTaxTotal: roundTwo(sum("rentTaxTotal")),
      rentGrossTotal: roundTwo(sum("rentGrossTotal")),
      // Sale totals
      saleNetTotal: roundTwo(sum("saleNetTotal")),
      saleTaxTotal: roundTwo(sum("saleTaxTotal")),
      saleGrossTotal: roundTwo(sum("saleGrossTotal")),
      // Service totals
      serviceNetTotal: roundTwo(sum("serviceNetTotal")),
      serviceTaxTotal: roundTwo(sum("serviceTaxTotal")),
      serviceGrossTotal: roundTwo(sum("serviceGrossTotal")),
      // Nursing totals
      nursingNetTotal: roundTwo(sum("nursingNetTotal")),
      nursingTaxTotal: roundTwo(sum("nursingTaxTotal")),
      nursingGrossTotal: roundTwo(sum("nursingGrossTotal")),
      // Grand
      netAmount: roundTwo(sum("netAmount")),
      totalCartage: roundTwo(sum("cartage")),
    };
  }, [selectedERFRows]);

  // ─── Generate combined invoice data object ─────────────────────────────────
  const generateCombinedInvoiceData = () => {
    if (!selectedERFRows.length || !mergedData) {
      console.warn("No ERF records selected");
      return null;
    }

    const firstRow = selectedERFRows[0];
    const today = new Date().toISOString().split("T")[0];

    // Combine all rent items from all ERFs into a single array
    const combinedItems = [];
    let itemLocalId = 1;

    selectedERFRows.forEach((erf) => {
      // Add rent items
      (erf.rentItems || []).forEach((item) => {
        combinedItems.push({
          ...item,
          local_id: itemLocalId++,
          equipmentRentNr: erf.equipmentRentNr,
        });
      });
      // Add sale items
      (erf.saleItems || []).forEach((item) => {
        combinedItems.push({
          ...item,
          local_id: itemLocalId++,
          equipmentRentNr: erf.equipmentRentNr,
        });
      });
      // Add service items
      (erf.serviceItems || []).forEach((item) => {
        combinedItems.push({
          ...item,
          local_id: itemLocalId++,
          equipmentRentNr: erf.equipmentRentNr,
        });
      });
      // Add nursing items
      (erf.nursingItems || []).forEach((item) => {
        combinedItems.push({
          ...item,
          local_id: itemLocalId++,
          equipmentRentNr: erf.equipmentRentNr,
        });
      });
    });

      const documentNumbers = selectedERFRows
    .map(erf => erf.documentNumber)
    .filter(Boolean);

  //   const documentNumbers = selectedERFRows
  // .flatMap(erf => erf.documentNumbers || (erf.documentNumber ? [erf.documentNumber] : []))
  // .filter(Boolean);

    const combinedData = {
      data: {
        // ERF Basic Info
        documentNumbers:documentNumbers ||[],
        erfType: firstRow.erfType || "Bulck",
        erfTypeCode: firstRow.erfTypeCode || "RE",
        erfTypeDescription: firstRow.erfTypeDescription || "Rent ERF Type",
        orderDate: today,
        salePoint: firstRow.salePoint || "MediRent",
        costCenter: firstRow.costCenter || "MediRent",
        erfCostCenterSubGroup: firstRow.erfCostCenterSubGroup || "SALESTEAM",
        privilegeCase: firstRow.privilegeCase || "NOT APPLICABLE",
        billingName: firstRow.billingName || "Patient",
        orderType: firstRow.orderType || "New",
        sourceOfCall: firstRow.sourceOfCall || "Other",
        companyName: firstRow.companyName || "Medirent",
        companyOrganisation: firstRow.companyOrganisation || "Medirent",
        companyNr: firstRow.companyNr || "C0010",
        companyCode: firstRow.companyCode || "MR - Medirent",
        
        // Doctor Info
        doctorName: firstRow.doctorName || "",
        drType: firstRow.drType || "Not Given",
        drListedType: firstRow.drListedType || "Select",
        drCode: firstRow.drCode || "",
        
        // Hospital Info
        patientErfHospitalName: firstRow.patientErfHospitalName || "",
        
        // Patient Info
        patientType: firstRow.patientType || "Listed",
        patient: firstRow.patient || firstRow.patientName || "Patient",
        patientName: firstRow.patientName || "Patient",
        mobileNr: firstRow.mobileNr || "",
        age: firstRow.age || 0,
        weight: firstRow.weight || 0,
        gender: firstRow.gender || "Male",
        gstNo: firstRow.gstNo || "",
        panNo: firstRow.panNo || "",
        isDiabetic: firstRow.isDiabetic || "No",
        aadharNo: firstRow.aadharNo || "",
        patientChallenges: firstRow.patientChallenges || "",
        AssociateNumber: firstRow.AssociateNumber || "",
        email: firstRow.email || "",
        address: firstRow.address || "HSR LAYOUT",
        address2: firstRow.address2 || "Sector 5",
        city: firstRow.city || "Bengaluru",
        
        // Hospital Details
        hospitalName: firstRow.hospitalName || "",
        hospitalAssociateNumber: firstRow.hospitalAssociateNumber || "",
        hospitalMobileNr: firstRow.hospitalMobileNr || "",
        hospitalEmail: firstRow.hospitalEmail || "",
        hospitalGstNo: firstRow.hospitalGstNo || "",
        hospitalAddress: firstRow.hospitalAddress || "",
        hospitalAddress2: firstRow.hospitalAddress2 || "",
        hospitalCity: firstRow.hospitalCity || "",
        hospitalState: firstRow.hospitalState || "",
        hospitalPinCode: firstRow.hospitalPinCode || "",
        hospitalBillingAddress: firstRow.hospitalBillingAddress || "",
        
        // Caregiver Info
        caregiverName: firstRow.caregiverName || "",
        caregiverMobileNr: firstRow.caregiverMobileNr || "",
        caregiverRelation: firstRow.caregiverRelation || "",
        idProof: firstRow.idProof || "Adhar Card",
        idProofNumber: firstRow.idProofNumber || "",
        emailId: firstRow.emailId || "",
        
        // Billing & Delivery Address
        billingAddress: addressInfo.billingAddress,
        billingState: addressInfo.billingState,
        billingPinCode: addressInfo.billingPinCode,
        deliveryAddress: addressInfo.deliveryAddress,
        deliveryState: addressInfo.deliveryState,
        deliveryPinCode: addressInfo.deliveryPinCode,
        
        // Financials
        cartage: mergedData.totalCartage || 0,
        installationCharges: firstRow.installationCharges || 0,
        receivedAmount: firstRow.receivedAmount || 0,
        paymentMode: firstRow.paymentMode || "NR",
        cashAmount: firstRow.cashAmount || 0,
        balanceAmtBreakup: firstRow.balanceAmtBreakup || "0.00",
        chequeNo: firstRow.chequeNo || "NA",
        cardTransNo: firstRow.cardTransNo || "NA",
        bankName: firstRow.bankName || "NA",
        receiptNo: firstRow.receiptNo || "NA",
        
        // Security Deposit
        standardSecurityAmt: firstRow.standardSecurityAmt || 0,
        receivedSecurityAmt: firstRow.receivedSecurityAmt || 0,
        securityPincode: firstRow.securityPincode || "570001",
        securityAmtMode: firstRow.securityAmtMode || "NR",
        securityCashAmt: firstRow.securityCashAmt || 0,
        balanceSecurityBreakup: firstRow.balanceSecurityBreakup || "0.00",
        securityChequeNo: firstRow.securityChequeNo || "NA",
        securityCardTransNo: firstRow.securityCardTransNo || "NA",
        securityBankName: firstRow.securityBankName || "NA",
        securityMode: firstRow.securityMode || "Card",
        securityModeCash: firstRow.securityModeCash || 0,
        securityModeBal: firstRow.securityModeBal || "95000",
        
        // Other Info
        remarks: firstRow.remarks || "test",
        approvalLevel: firstRow.approvalLevel || "1",
        approvers: firstRow.approvers || [],
        version: firstRow.version || "V1",
        expectedDeliveryDate: firstRow.expectedDeliveryDate || today,
        expectedDeliveryTime: firstRow.expectedDeliveryTime || "10:55",
        
        // Nurse Info
        nurseUserId: firstRow.nurseUserId || "",
        nurseName: firstRow.nurseName || "",
        nurseAssociateNumber: firstRow.nurseAssociateNumber || "",
        nurseMobileNr: firstRow.nurseMobileNr || "",
        nurseEmail: firstRow.nurseEmail || "",
        nurseAddress: firstRow.nurseAddress || "",
        nurseAddress2: firstRow.nurseAddress2 || "",
        nurseCity: firstRow.nurseCity || "",
        nursePanNo: firstRow.nursePanNo || "",
        nurseBillingAddress: firstRow.nurseBillingAddress || "",
        nurseBillingState: firstRow.nurseBillingState || "",
        nurseBillingPinCode: firstRow.nurseBillingPinCode || "",
        
        // Service Provider
        serviceProviderCode: firstRow.serviceProviderCode || "SEREX01",
        serviceProviderName: firstRow.serviceProviderName || "Akash Singh",
        
        // Cartage Breakdown
        salesCartage: firstRow.salesCartage || 0,
        rentCartage: firstRow.rentCartage || 0,
        selectedCompanyId: firstRow.selectedCompanyId || "MR - Medirent",
        
        // ERF Type Details
        erfTypeName: firstRow.erfTypeName || "Rent",
        erfForType: firstRow.erfForType || "Patient",
        erfForTypeName: firstRow.erfForTypeName || "Patient",
        erfForTypeCode: firstRow.erfForTypeCode || "PAT",
        
        // ERF Dates
        erfStartDate: firstRow.erfStartDate || today,
        erfEndDate: firstRow.erfEndDate || today,
        erfReminderDate: firstRow.erfReminderDate || today,
        erfReminderDaysBeforeEnd: firstRow.erfReminderDaysBeforeEnd || 3,
        
        // Workflow Status
        pcCallStatus: firstRow.pcCallStatus || "",
        pcCallStatusCode: firstRow.pcCallStatusCode || "",
        extensionLifecycleStatus: firstRow.extensionLifecycleStatus || "ACTIVE",
        childExtensionNr: firstRow.childExtensionNr || null,
        levelOfApproval: firstRow.levelOfApproval || "1",
        approverList: firstRow.approverList || [],
        triggerWorkflow: firstRow.triggerWorkflow || false,
        approvalReason: firstRow.approvalReason || "",
        approverUserId1: firstRow.approverUserId1 || "",
        approverUsername1: firstRow.approverUsername1 || "",
        approverUserId2: firstRow.approverUserId2 || "",
        approverUsername2: firstRow.approverUsername2 || "",
        createdBy: firstRow.createdBy || "M000",
        
        // Financial Totals
        netAmount: mergedData.netAmount || 0,
        balanceAmount: mergedData.netAmount || 0,
        balanceSecurityAmt: firstRow.balanceSecurityAmt || 95000,
        
        // ERF Status
        erfStatusCode: firstRow.erfStatusCode || "DPD",
        erfStatus: firstRow.erfStatus || "Dispatched",
        
        // Section Totals
        rentNetTotal: mergedData.rentNetTotal || 0,
        rentTaxTotal: mergedData.rentTaxTotal || 0,
        rentGrossTotal: mergedData.rentGrossTotal || 0,
        rentSecurityTotal: firstRow.rentSecurityTotal || 95000,
        saleNetTotal: mergedData.saleNetTotal || 0,
        saleTaxTotal: mergedData.saleTaxTotal || 0,
        saleGrossTotal: mergedData.saleGrossTotal || 0,
        serviceNetTotal: mergedData.serviceNetTotal || 0,
        serviceTaxTotal: mergedData.serviceTaxTotal || 0,
        serviceGrossTotal: mergedData.serviceGrossTotal || 0,
        nursingNetTotal: mergedData.nursingNetTotal || 0,
        nursingTaxTotal: mergedData.nursingTaxTotal || 0,
        nursingGrossTotal: mergedData.nursingGrossTotal || 0,
        lineItemNetTotal: mergedData.rentNetTotal + mergedData.saleNetTotal + 
                          mergedData.serviceNetTotal + mergedData.nursingNetTotal,
        lineItemTaxTotal: mergedData.rentTaxTotal + mergedData.saleTaxTotal + 
                          mergedData.serviceTaxTotal + mergedData.nursingTaxTotal,
        lineItemGrossTotal: mergedData.rentGrossTotal + mergedData.saleGrossTotal + 
                            mergedData.serviceGrossTotal + mergedData.nursingGrossTotal,
        lineItemGrossRounded: Math.round((mergedData.rentGrossTotal + mergedData.saleGrossTotal + 
                                          mergedData.serviceGrossTotal + mergedData.nursingGrossTotal) * 100) / 100,
        roundOffAmount: firstRow.roundOffAmount || 0,
        
        // Items Arrays
        rentItems: mergedData.rentItems || [],
        saleItems: mergedData.saleItems || [],
        serviceItems: mergedData.serviceItems || [],
        nursingItems: mergedData.nursingItems || [],
        
        // References
        equipmentRentNr: selectedERFRows.map(erf => erf.equipmentRentNr).filter(Boolean).join(", "),
  //      equipmentRentNr: selectedERFRows
  // .flatMap(erf => erf.documentNumbers || [erf.equipmentRentNr])
  // .filter(Boolean).join(", "),
  // equipmentNr: selectedERFRows
  // .flatMap(erf => erf.documentNumbers || [erf.equipmentNr])
  // .filter(Boolean).join(", "),
        equipmentNr: selectedERFRows.map(erf => erf.equipmentNr).filter(Boolean).join(", "),
        equipmentStatus: firstRow.equipmentStatus || "Approved",
        status: firstRow.status || "Approved",
        createdByName: firstRow.createdByName || "MediRent",
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        timeZone: "Asia/Calcutta",
        typeOfOperation:"Bulk",
        // Combined Items for Invoice
        items: combinedItems,
           "transaction": "Sales",
    "transactionType": "INV",
      },
      timeZone: "Asia/Calcutta",
    };

    // console.log("Combined Invoice Data:", JSON.stringify(combinedData, null, 2));
    
    // Here you would typically make an API call to save the invoice
    // await apiService.createBulkInvoice(combinedData);
    
    return combinedData;
  };

  // const handleGenerateInvoice = () => {
  //   const invoiceData = generateCombinedInvoiceData();
  //   if (invoiceData) {
  //     // You can also show a success message or navigate to invoice preview
  //     alert(`Invoice generated successfully for ${selectedERFRows.length} ERF(s)!`);
  //   } else {
  //     alert("No ERF records selected. Please select at least one ERF.");
  //   }
  // };

  const handleGenerateInvoice = async () => {
      
      try {
         const invoiceData = generateCombinedInvoiceData();
         console.log(">>invoiceData",invoiceData)
        
        setDisabled(true);
        const response = await ItemServiceV2.addInvoice(invoiceData);
        if (response?.status === 200) {
          toast.success(response?.message || "Added successfully", {
            duration: 2000,
            position: "top-right",
          });
  
          navigate(CustomerConstants?.CUSTOMER_V5_MR_ERF_INVOICE_LIST)
        
        } else {
          toast.error(response?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (error) {
        toast.error("Something went wrong!", {
          duration: 4000,
          position: "top-right",
        });
      } finally {
        setDisabled(false);
      }
    };

  // ─── Reusable: Accordion wrapper (exact pattern from ErfInvoiceModal) ───────
  const AccordionBlock = ({ logo, title, subTitle, isVisible, onToggle, children }) => (
    <div className="accordion mb-4">
      <div className="accordion-item">
        <h2 className="accordion-header">
          <Row className="accordion-button">
            <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
              <i
                className={`bi ${isVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
                onClick={onToggle}
              ></i>
            </Col>
            <Col xs={1} md={1} lg={1} className="text-center logoBtn">
              <span className="iconLogo">{logo}</span>
            </Col>
            <Col xs={4} md={4} lg={4}>
              <span className="headerTitle">{title}</span>
              <span className="subHeaderTitle">{subTitle}</span>
            </Col>
          </Row>
        </h2>
        <div className={`accordion-collapse collapse show ${isVisible ? "visible" : ""}`}>
          <div className="accordion-body">
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="accordion-body">{children}</div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );

  // ─── Reusable: 3-field totals row (exact pattern from ErfInvoiceModal) ──────
  const TotalsBlock = ({ label, netTotal, taxTotal, grossTotal }) => (
    <Row className="pt-2 pb-4">
      <Col xs={12} md={6} lg={3} className="commTopButtonRightLeftPadding">
        <InputField
          className="inputBox"
          label="Total Amount"
          name={`${label}_netTotal`}
          id={`${label}_netTotal`}
          value={netTotal ?? 0}
          disabled={true}
        />
      </Col>
      <Col xs={12} md={6} lg={3} className="commTopButtonRightLeftPadding">
        <InputField
          className="inputBox"
          label="Total GST"
          name={`${label}_taxTotal`}
          id={`${label}_taxTotal`}
          value={taxTotal ?? 0}
          disabled={true}
        />
      </Col>
      <Col xs={12} md={6} lg={3} className="commTopButtonRightLeftPadding">
        <InputField
          className="inputBox"
          label="Gross Amount"
          name={`${label}_grossTotal`}
          id={`${label}_grossTotal`}
          value={grossTotal ?? 0}
          disabled={true}
        />
      </Col>
    </Row>
  );

  // ─── Column definitions ─────────────────────────────────────────────────────

  // Summary table (selected ERF list)
  const summaryColumns = [
    {
      name: "ERF No",
      cell: (row) => <span className="fw-bold text-primary">{row.documentNumber}</span>,
      width: "200px",
    },
    {
      name: "Created Date",
      cell: (row) => <span>{formatDateWithAMPM(row.createdAt)}</span>,
      width: "190px",
    },
    {
      name: "ERF Status",
      cell: (row) => <TableStatusField status={row.erfStatus} />,
      width: "180px",
    },
    {
      name: "ERF Type",
      cell: (row) => <TableStatusField status={row.erfType} />,
      width: "130px",
    },
    {
      name: "Patient Name",
      selector: (row) => row.patientName,
      width: "150px",
    },
    {
      name: "Hospital",
      selector: (row) => row.hospitalName,
      width: "200px",
    },
    {
      name: "Net Amount",
      cell: (row) => (
        <span className="fw-bold" style={{ color: "blue" }}>
          {Number(row.netAmount || 0).toFixed(2)} INR
        </span>
      ),
      width: "130px",
      right: true,
    },
  ];

  // Shared ERF No column (appears in every item table)
  const erfNoCol = {
    name: "ERF No",
    cell: (row) => (
      <span className="fw-bold text-primary" style={{ fontSize: "11px" }}>
        {row?.parentDocumentNumber}
      </span>
    ),
    width: "160px",
  };

  const slNoCol = {
    name: "Sl No.",
    cell: (row) => <p className="m-0 p-0">{row?.equipmentItemNr}</p>,
    width: "70px",
  };

  const productCol = {
    name: "Product",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription}</p>
        <p className="m-0 p-0">{row?.materialCode}</p>
      </div>
    ),
    width: "180px",
  };

  const qtyCol = {
    name: "Qty",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 fw-bold">{row?.orderedQuantity}</p>
        <p className="m-0 p-0">{row?.orderUnitOfMeasure}</p>
      </div>
    ),
    width: "80px",
  };

  const netValueCol = { name: "Net Value", cell: (row) => <span>{row?.netValue ?? "--"}</span>, width: "100px" };
  const gstCol = { name: "GST (%)", cell: (row) => <span>{row?.taxPercentage ?? "--"}</span>, width: "90px" };
  const taxAmtCol = { name: "Tax Amt", cell: (row) => <span>{row?.taxAmount ?? "--"}</span>, width: "100px" };
  const grossAmtCol = { name: "Gross Amt", cell: (row) => <span>{row?.grossValue ?? "--"}</span>, width: "110px" };

  // Rent Items columns (matches ErfInvoiceModal lineItemCol)
  const rentItemColumns = [
    slNoCol, erfNoCol, productCol, qtyCol,
    { name: "Barcode", selector: (row) => row?.barcode || "--", width: "120px" },
    { name: "From Date", cell: (row) => <span>{formatDate(row?.fromDate)}</span>, width: "120px" },
    { name: "To Date", cell: (row) => <span>{formatDate(row?.toDate)}</span>, width: "120px" },
    { name: "Rent Slab", selector: (row) => row?.rentSlab, width: "110px" },
    netValueCol, gstCol, taxAmtCol, grossAmtCol,
  ];

  // Sale Items columns (matches ErfInvoiceModal saleLineItemCol)
  const saleItemColumns = [
    slNoCol, erfNoCol, productCol, qtyCol,
    { name: "Barcode", selector: (row) => row?.barcode || "--", width: "120px" },
    { name: "Date", cell: (row) => <span>{formatDate(row?.fromDate)}</span>, width: "120px" },
    netValueCol, gstCol, taxAmtCol, grossAmtCol,
  ];

  // Service Items columns
  const serviceItemColumns = [
    slNoCol, erfNoCol, productCol, qtyCol,
    { name: "Date", cell: (row) => <span>{formatDate(row?.fromDate)}</span>, width: "120px" },
    netValueCol, gstCol, taxAmtCol, grossAmtCol,
  ];

  // Nursing Items columns (matches ErfInvoiceModal nursingItemsCol)
  const nursingItemColumns = [
    slNoCol, erfNoCol, productCol, qtyCol,
    { name: "Date", cell: (row) => <span>{formatDate(row?.fromDate)}</span>, width: "120px" },
    netValueCol, gstCol, taxAmtCol, grossAmtCol,
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">

            {/* ── Page Header ─────────────────────────────────────────────── */}
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">ERF Bulk Invoice Creation</h2>
                <p className="subText">
                  {selectedERFRows.length} ERF record(s) selected for bulk
                  invoice generation
                </p>
              </Col>
              {/* <Col xs={12} md={4} lg={4} className="text-end">
                <Button 
                  variant="primary" 
                  onClick={handleGenerateInvoice}
                  disabled={selectedERFRows.length === 0}
                  style={{ 
                    backgroundColor: "#2d7a79", 
                    borderColor: "#2d7a79",
                    padding: "10px 24px",
                    fontWeight: "bold"
                  }}
                >
                  <i className="bi bi-file-earmark-text me-2"></i>
                  Generate Invoice
                </Button>
              </Col> */}
            </Row>
            <hr />

            {/* ── ADDRESS BLOCK (First Block) ───────────────────────────────────── */}
            <Row className="mb-4 p-3" style={{ 
              border: "1px solid #dee2e6", 
              borderRadius: "8px",
              backgroundColor: "#f8f9fa"
            }}>
              <Col xs={12} md={6} lg={6}>
                <div>
                  <h5 style={{ color: "#2d7a79", fontWeight: "bold", marginBottom: "8px" }}>
                    {addressInfo.companyName}
                  </h5>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.address}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.gst}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    Email: {addressInfo.email}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    Contact: {addressInfo.contact}
                  </p>
                </div>
              </Col>
              <Col xs={12} md={3} lg={3}>
                <div>
                  <p style={{ fontWeight: "bold", marginBottom: "4px", color: "#333" }}>
                    Billing:
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.billingName}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.billingAddress}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.billingState}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.billingPinCode}
                  </p>
                </div>
              </Col>
              <Col xs={12} md={3} lg={3}>
                <div>
                  <p style={{ fontWeight: "bold", marginBottom: "4px", color: "#333" }}>
                    Delivery Address:
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.deliveryAddress}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.deliveryState}
                  </p>
                  <p style={{ margin: "0", fontSize: "13px", color: "#555" }}>
                    {addressInfo.deliveryPinCode}
                  </p>
                </div>
              </Col>
            </Row>

            {/* ── Grand Summary Cards ──────────────────────────────────────── */}
            {/* {mergedData && (
              <Row className="mb-3 px-2">
                {[
                  { label: "Total ERFs", value: selectedERFRows.length, color: "#2d7a79" },
                  { label: "Rent Items", value: mergedData.rentItems.length, color: "#0d6efd" },
                  { label: "Sale Items", value: mergedData.saleItems.length, color: "#6610f2" },
                  { label: "Service Items", value: mergedData.serviceItems.length, color: "#fd7e14" },
                  { label: "Nursing Items", value: mergedData.nursingItems.length, color: "#20c997" },
                  { label: "Grand Net Amt (INR)", value: mergedData.netAmount.toFixed(2), color: "#dc3545" },
                ].map((card, i) => (
                  <Col xs={6} md={4} lg={2} key={i} className="mb-2">
                    <div style={{ border: `2px solid ${card.color}`, borderRadius: "8px", padding: "10px 12px", textAlign: "center" }}>
                      <p style={{ color: card.color, fontWeight: "bold", fontSize: "18px", margin: 0 }}>{card.value}</p>
                      <p style={{ fontSize: "11px", margin: 0, color: "#666" }}>{card.label}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            )} */}

            {/* ══ ACCORDION 1 — Selected ERF Summary List ═══════════════════ */}
            <AccordionBlock
              logo="EL"
              title="Selected ERF List"
              subTitle="Review selected records before generating invoice"
              isVisible={isCardVisible}
              onToggle={() => setCardVisible(!isCardVisible)}
            >
              {selectedERFRows.length === 0 ? (
                <p className="text-center text-muted p-4">
                  No ERF records selected. Please go back and select records.
                </p>
              ) : (
                <DataTable
                  title=""
                  columns={summaryColumns}
                  data={selectedERFRows}
                  pagination
                  highlightOnHover
                  persistTableHead
                />
              )}
            </AccordionBlock>

            {/* ══ ACCORDION 2 & 3 — RENT ITEMS + RENT TOTALS ═══════════════ */}
            {mergedData?.rentItems?.length > 0 && (
              <>
                <AccordionBlock
                  logo="RI"
                  title="Rent Items"
                  subTitle="Combined rent items from all selected ERFs"
                  isVisible={isCardVisible2}
                  onToggle={() => setCardVisible2(!isCardVisible2)}
                >
                  <Row className="pt-2 pb-4">
                    <DataTable
                      title=""
                      columns={rentItemColumns}
                      data={mergedData.rentItems}
                      pagination
                      highlightOnHover
                      persistTableHead
                    />
                  </Row>
                </AccordionBlock>

                <AccordionBlock
                  logo="RD"
                  title="Rent Details"
                  subTitle="Combined rent totals"
                  isVisible={isCardVisible3}
                  onToggle={() => setCardVisible3(!isCardVisible3)}
                >
                  <TotalsBlock
                    label="rent"
                    netTotal={mergedData.rentNetTotal}
                    taxTotal={mergedData.rentTaxTotal}
                    grossTotal={mergedData.rentGrossTotal}
                  />
                </AccordionBlock>
              </>
            )}

            {/* ══ ACCORDION 4 & 5 — SALE ITEMS + SALE TOTALS ═══════════════ */}
            {mergedData?.saleItems?.length > 0 && (
              <>
                <AccordionBlock
                  logo="SI"
                  title="Sale Items"
                  subTitle="Combined sale items from all selected ERFs"
                  isVisible={isCardVisible4}
                  onToggle={() => setCardVisible4(!isCardVisible4)}
                >
                  <Row className="pt-2 pb-4">
                    <DataTable
                      title=""
                      columns={saleItemColumns}
                      data={mergedData.saleItems}
                      pagination
                      highlightOnHover
                      persistTableHead
                    />
                  </Row>
                </AccordionBlock>

                <AccordionBlock
                  logo="SD"
                  title="Sale Details"
                  subTitle="Combined sale totals"
                  isVisible={isCardVisible5}
                  onToggle={() => setCardVisible5(!isCardVisible5)}
                >
                  <TotalsBlock
                    label="sale"
                    netTotal={mergedData.saleNetTotal}
                    taxTotal={mergedData.saleTaxTotal}
                    grossTotal={mergedData.saleGrossTotal}
                  />
                </AccordionBlock>
              </>
            )}

            {/* ══ ACCORDION 6 & 7 — NURSING ITEMS + NURSING TOTALS ═════════ */}
            {mergedData?.nursingItems?.length > 0 && (
              <>
                <AccordionBlock
                  logo="NI"
                  title="Nursing Items"
                  subTitle="Combined nursing items from all selected ERFs"
                  isVisible={isCardVisible6}
                  onToggle={() => setCardVisible6(!isCardVisible6)}
                >
                  <Row className="pt-2 pb-4">
                    <DataTable
                      title=""
                      columns={nursingItemColumns}
                      data={mergedData.nursingItems}
                      pagination
                      highlightOnHover
                      persistTableHead
                    />
                  </Row>
                </AccordionBlock>

                <AccordionBlock
                  logo="ND"
                  title="Nursing Details"
                  subTitle="Combined nursing totals"
                  isVisible={isCardVisible7}
                  onToggle={() => setCardVisible7(!isCardVisible7)}
                >
                  <TotalsBlock
                    label="nursing"
                    netTotal={mergedData.nursingNetTotal}
                    taxTotal={mergedData.nursingTaxTotal}
                    grossTotal={mergedData.nursingGrossTotal}
                  />
                </AccordionBlock>
              </>
            )}

            {/* ══ ACCORDION 8 & 9 — SERVICE ITEMS + SERVICE TOTALS ═════════ */}
            {mergedData?.serviceItems?.length > 0 && (
              <>
                <AccordionBlock
                  logo="SV"
                  title="Service Items"
                  subTitle="Combined service items from all selected ERFs"
                  isVisible={isCardVisible8}
                  onToggle={() => setCardVisible8(!isCardVisible8)}
                >
                  <Row className="pt-2 pb-4">
                    <DataTable
                      title=""
                      columns={serviceItemColumns}
                      data={mergedData.serviceItems}
                      pagination
                      highlightOnHover
                      persistTableHead
                    />
                  </Row>
                </AccordionBlock>

                <AccordionBlock
                  logo="SvD"
                  title="Service Details"
                  subTitle="Combined service totals"
                  isVisible={isCardVisible9}
                  onToggle={() => setCardVisible9(!isCardVisible9)}
                >
                  <TotalsBlock
                    label="service"
                    netTotal={mergedData.serviceNetTotal}
                    taxTotal={mergedData.serviceTaxTotal}
                    grossTotal={mergedData.serviceGrossTotal}
                  />
                </AccordionBlock>
              </>
            )}

            {/* ══ GRAND TOTAL FOOTER ════════════════════════════════════════ */}
            {mergedData && (
              <div
                style={{
                  border: "2px solid #2d7a79",
                  borderRadius: "8px",
                  padding: "16px 20px",
                  background: "#f0faf9",
                  marginBottom: "24px",
                }}
              >
                <Row className="align-items-center">
                  <Col xs={12} md={3} lg={2}>
                    <p className="fw-bold mb-1" style={{ color: "#2d7a79", fontSize: "15px" }}>
                      Grand Total Summary
                    </p>
                    <p className="mb-0" style={{ fontSize: "12px", color: "#666" }}>
                      Across {selectedERFRows.length} ERF(s)
                    </p>
                  </Col>
                  {[
                    { label: "Rent Gross", value: mergedData.rentGrossTotal, show: mergedData.rentItems.length > 0 },
                    { label: "Sale Gross", value: mergedData.saleGrossTotal, show: mergedData.saleItems.length > 0 },
                    { label: "Service Gross", value: mergedData.serviceGrossTotal, show: mergedData.serviceItems.length > 0 },
                    { label: "Nursing Gross", value: mergedData.nursingGrossTotal, show: mergedData.nursingItems.length > 0 },
                    { label: "Total Cartage", value: mergedData.totalCartage, show: true },
                    { label: "Grand Net Amt", value: mergedData.netAmount, show: true, highlight: true },
                  ]
                    .filter((c) => c.show)
                    .map((card, i) => (
                      <Col xs={6} md={2} lg={2} key={i} className="mb-1">
                        <p style={{ fontWeight: "bold", fontSize: card.highlight ? "16px" : "14px", color: card.highlight ? "#dc3545" : "#333", margin: 0 }}>
                          {Number(card.value || 0).toFixed(2)} INR
                        </p>
                        <p style={{ fontSize: "11px", color: "#888", margin: 0 }}>{card.label}</p>
                      </Col>
                    ))}
                </Row>
              </div>
            )}

          </div>
        </Col>
      </Row>
        <Row className="mb-2">
             
<Col
  xs={12}
  md={{ offset: 8, span: 4 }}
  lg={{ offset: 8, span: 4 }}
  className="text-end mb-4"
>                <Button 
                  variant="primary" 
                  onClick={handleGenerateInvoice}
                  disabled={selectedERFRows.length === 0 || disable}
                  style={{ 
                    backgroundColor: "#2d7a79", 
                    borderColor: "#2d7a79",
                    padding: "10px 24px",
                    fontWeight: "bold"
                  }}
                >
                  <i className="bi bi-file-earmark-text me-2"></i>
                  Generate Invoice
                </Button>
              </Col>
            </Row>
    </main>
  );
};

export default BulkERFInvoiceCreation;